import React from 'react'
import Pagination from '../../Hocs/Pagination'

import Page from './page'

export default Pagination({
  numberOfSlides: props => props.totalPages,
  renderItem: (props, index) => {
    const { currentPage, sidebarWidth } = props
    return (
      <Page
        url={props.filesToDownload[`help${index + 1}.png`]}
        active={currentPage === index}
        sidebarWidth={sidebarWidth}
      />
    )
  }
})
